(function () {
    'use strict';

    angular.module('app').factory('ExportService', ExportService);

    ExportService.$inject = ['$rootScope', 'API', '$filter', 'CustomerService', 'TransactionService'];

    function ExportService($rootScope, API, $filter, CustomerService, TransactionService) {
        var service = {};

        service.getTransactions = function (params) {
            var cacheCustomerLite = [];
            return new Promise(function (resolve) {
                TransactionService.All(params, function (success, response) {
                    if (params.include_questionnaire) {

                        var promisesParams = [];
                        response.data.forEach(function (row) {
                            promisesParams.push(row);
                        });
                        var cacheCustomerLite = [];
                        promisesParams.reduce(function (acc, row) {
                            return acc.then(function (res) {
                                return new Promise(function (resolve) {
                                    if (!!row.user_id) {
                                        if (cacheCustomerLite[row.user_id + row.loyalty_id]) {
                                            row.external_customer_info = cacheCustomerLite[row.user_id + row.loyalty_id];
                                            resolve(row);
                                        } else {
                                            CustomerService.CustomerLite(row.user_id, row.loyalty_id, function (success, response) {
                                                if (success) {
                                                    row.external_customer_info = response;
                                                    cacheCustomerLite[row.user_id + row.loyalty_id] = response;
                                                }
                                                resolve(row);
                                            });
                                        }
                                    } else {
                                        resolve(row);
                                    }
                                }).then(function (resp) {
                                    return [...res, resp];
                                });
                            });
                        }, Promise.resolve([])).then(function (values) {
                            response.data = values;
                            resolve(response);
                        });
                    } else {
                        resolve(response);
                    }
                });
            });
        };

        // Формирование значений прогрессбара для модального окна
        service.calculateExportValuesCount = function ($scope, exportValues, totalRowsCount) {
            var dataLength = 0;
            // todo проверить условие
            if (exportValues && exportValues.length > 0) {
                exportValues.forEach(function (value) {
                    dataLength += value.data ? value.data.length : 0;
                });
            }
            $scope.$apply(function ($scope) {
                $scope.exportModal.downloadedDataCount = dataLength;
                $scope.exportModal.allDataCount = totalRowsCount;
                $scope.exportModal.exportProgress = $scope.exportModal.downloadedDataCount / $scope.exportModal.allDataCount * 100;
            });
        };

        // Формирование массива параметров для загрузки массивов записей
        service.generateExportParams = function (startParams, totalRowsCount, partCount) {
            var params = [];
            if (Math.ceil(totalRowsCount / partCount) !== 0) {
                for (var i = 0; i < Math.ceil(totalRowsCount / partCount); i++) {
                    startParams.page = i + 1;
                    startParams.count = partCount;
                    params.push(angular.copy(startParams));
                }
                return params;
            } else {
                return [Object.assign(startParams, {page: 1, count: partCount})];
            }
        };

        service.getTableForExcel = function (format, columns) {
            var struct = [];
            for (var i in columns) {
                var exportColumn = columns[i].enabled != null ? columns[i].enabled && columns[i].visible : columns[i].visible;
                if (exportColumn && !columns[i].no_export) {
                    for (var k in columns[i].data) {
                        if (columns[i].data[k].visible && !columns[i].data[k].no_export) {
                            if (columns[i].data[k].onlyForExport) {
                                if (columns[i].data[k].value.indexOf('blank_') !== -1) {
                                    struct.push({
                                        text: ' '.repeat(i),
                                        value: ''
                                    });
                                } else {
                                    struct.push({
                                        text: $filter('translate')(columns[i].data[k].text),
                                        value: columns[i].data[k].value
                                    });
                                }
                            } else {
                                var text = columns[i].data[k].text;
                                struct.push({
                                    text: $filter('translate')(text) || text,
                                    value: columns[i].data[k].value,
                                    dateFormat: columns[i].data[k].dateFormat
                                });
                            }
                        }
                    }
                }
            }
            return struct;
        };

        return service;
    }

})();
